import actions from './actions'

export default function BankInfosReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_BANKINFO:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_BANKINFO:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_BANKINFO:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_BANKINFO:
      return {
        ...state,
        editing: { bankInfoID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_BANKINFO_RECIEVED ||
      actions.UPDATE_BANKINFO_RECIEVED ||
      actions.DELETE_BANKINFO_RECIEVED:
      return {
        ...state,
        editing: { bankInfoID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
